// react
import React from "react";
// @mui
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";

type Props = {
  children: React.ReactNode;
};

const CompactLayout = ({ children }: Props) => {
  return (
    <>
      <Container component="main">
        <Stack
          sx={{
            pt: 0,
            pb: 12,
            m: "auto",
            maxWidth: 400,
            minHeight: "100vh",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          {children}
        </Stack>
      </Container>
    </>
  );
};
export default CompactLayout;
